import React from 'react'
import Game from './Game'
import { render, getConfig, assetsUrl, GameProvider, CONTENT_TYPE, removeAccentsAndConvertLowercase, areTextsEqual, initErrorMonitoring } from '@educaplay/core'
import { initialize } from '@educaplay/store'
import { createCustomization } from '@educaplay/core/utils/customization';

initErrorMonitoring("https://6149f1eb4cc1bcccc9263d94aaf718db@o4509038211104768.ingest.de.sentry.io/4509440946733136", {
  tracesSampleRate: 0.05
});

const WHEEL_SOUNDS = {
  'wheel-rotate': assetsUrl('RULETA_PALABRAS/mover.mp3'),
  'wheel-letterActive': assetsUrl('RULETA_PALABRAS/bienactivo.mp3'),
  'wheel-submit': assetsUrl('RULETA_PALABRAS/activar.mp3'),
  'wheel-skip': assetsUrl('RULETA_PALABRAS/colocar.mp3'),
  'wheel-write': assetsUrl('RULETA_PALABRAS/escribir.mp3'),
  'wheel-delete': assetsUrl('RULETA_PALABRAS/carga.mp3'),
  'wheel-correct': assetsUrl('RULETA_PALABRAS/correcto.mp3')
}

const gameImage = assetsUrl("RULETA_PALABRAS/logoActivity.png");

const container = document.getElementById('root');

async function init() {
  const { data, texts, settings, user, title, description, author, id, url } = await getConfig().catch((err) =>
    console.error('Error al obtener la configuración: ', err)
  )

  const isCaseSensitive = data.SENSIBLE_MAYUSCULAS_ACENTOS === 'si';

  const { resources } = settings
  const filteredQuestions = data.PREGUNTAS
    .map((question, index) => ({ ...question, id: index }))
    .filter((question) => question.LETRA !== "")
    .filter((question) => question.LETRA_INICIAL === "si" || question.LETRA_INICIAL === "no")
    .filter((question) => question.RESPUESTAS.length !== 0)
    .filter((question) => question.RESPUESTAS.every((component) => component.RESPUESTA !== ""))

  const hasBank = filteredQuestions.some((question) => {
    return (!!(question.ENUNCIADO || question.MULTIMEDIA))
  })

  const questionTimeNumber = Number(data.TIEMPO)
  const questionTime = Number.isNaN(questionTimeNumber) ? 0 : questionTimeNumber

  const questions = filteredQuestions.map(question => {
    const correctAnswers = question.RESPUESTAS.map(answer => answer.RESPUESTA.trim());

    const checkAnswer = (answer) => {
      if (answer === '') return false;
      if (isCaseSensitive) {
        return correctAnswers.includes(answer);
      }

      //No es sensible a Mayusculas y Acentos
      const formattedAnswer = removeAccentsAndConvertLowercase(answer);
      const formattedCorrectAnswers = correctAnswers.map(correctAnswer => removeAccentsAndConvertLowercase(correctAnswer));
      for (let i = 0; i < correctAnswers.length; i++) {
        if (areTextsEqual(formattedAnswer, formattedCorrectAnswers[i])) {
          return true
        }
      }
      return false;
    }

    return {
      text: question.LETRA,
      bank: (question.ENUNCIADO || question.MULTIMEDIA) ? {
        text: question.ENUNCIADO.trim(),
        source: question.MULTIMEDIA ? `${resources}${question.MULTIMEDIA}` : null,
        type: question.MULTIMEDIA_TIPO ?? CONTENT_TYPE.TEXT
      } : null,
      checkAnswer,
      isStartLetter: question.LETRA_INICIAL === "si",
      correctAnswers,
      answer: null,
      points: 100 / filteredQuestions.length,
      time: questionTime,
      id: question.id,
    }
  });

  initialize({
    lives: data.NUMERO_INTENTOS,
    liveActived: data.NUMERO_INTENTOS_INFINITOS !== "si",
    hasCountDown: data.MAXIMO === "si",
    randomized: data.ALEATORIO === "si",
    countFooterSpace: true,
    showSolutions: data.OCULTAR_RESPUESTAS !== '1',
    showRestart: data.OCULTAR_REINICIAR !== '1',
    showSocialMedia: data.OCULTAR_REDES !== '1',
    showUserAnswer: true,
    finalText: data.TEXTO_FINAL,
    hasSkip: true,
    hasBank,
    questions,
    settings,
    title,
    description,
    author,
    id,
    url,
    user,
    customizations: createCustomization(data)
  });

  render(container, (
    <React.StrictMode>
      <GameProvider
        gameImage={gameImage}
        texts={texts}
        Game={Game}
        sounds={WHEEL_SOUNDS}
      //pueden hacer falta renders, o no
      />
    </React.StrictMode>
  ))
}

init();